import { FormsModule } from '@angular/forms';
import { MbscModule } from '@mobiscroll/angular';
import { HttpModule, JsonpModule } from '@angular/http';

import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HttpService } from '../providers/http-service';
import { LoadingService } from '../providers/loading-service';
import { RegistService } from '../providers/regist-service';
import { AuthService } from '../providers/auth-service';
import { HttpReserveProvider } from '../providers/http-reserve';
import { HttpFamilyProvider } from '../providers/http-family';
import { HttpChildProvider } from '../providers/http-child';
import { HttpChatProvider } from '../providers/http-chat';
import { HttpStaffProvider } from '../providers/http-staff';


import { AuthStore } from '../stores/auth-store';
import { ReserveStore } from '../stores/reserve-store';
import { FamilyStore } from '../stores/family-store';
import { ChildStore } from '../stores/child-store';
import { PickupStore } from '../stores/pickup-store';

import { BasicState } from '../states/basic-state';

import { ReserveAction} from '../actions/reserve.action';
import { ChildAction} from '../actions/child.action';


@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    FormsModule,
    MbscModule,
    HttpModule,
    JsonpModule,
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition'
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    LoadingService,
    HttpService,
    RegistService,
    AuthStore,
    AuthService,
    HttpReserveProvider,
    HttpFamilyProvider,
    HttpChildProvider,
    HttpChatProvider,
    ReserveStore,
    FamilyStore,
    ChildStore,
    BasicState,
    PickupStore,
    ReserveAction,
    ChildAction,
    HttpStaffProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts